import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseAnimate, FuseUtils} from '@fuse';
import {bindActionCreators} from 'redux';
import ReactTable from "react-table";
import moment from "moment";
import {MenuItem, Select} from "@material-ui/core/index";

class SurveyLinkList extends Component {

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    render() {
        const {survey, searchText} = this.props;
        const data = this.getFilteredArray(survey.map(s => ({
            ...s,
            shortenedId: s.id.split('-')[0]+'-'+s.id.split('-')[1],
            lastUpdate: moment(s.updated_at).format('YYYY/MM/DD HH:mm:ss'),
            clicks: s.surveyClick.length,
        })), searchText);

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    filterable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有任何問卷點擊紀錄"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    defaultFiltered={[
                        { id: 'trigger_type', value: 'all'},
                    ]}
                    data={
                        data.sort((preMission, currMission) => currMission.id - preMission.id).map(row => {
                            const { user } = row

                            const livingArea = (user.vip && user.vip.livingArea && user.vip.livingArea.name)
                                || (user.city && user.city.name)
                                || '（無）'

                            return {
                                ...row,
                                livingArea,
                            }
                        })
                    }
                    columns={[
                        {
                            Header: "連結代碼",
                            accessor: "shortenedId",
                            filterable: true,
                            className: "justify-center",
                            width: 120,
                            Cell: row => (<div title={row.original.id}>{row.value}</div>)
                        },
                        {
                            Header: "使用者",
                            accessor: "user.name",
                            filterable: true,
                            className: "justify-center",
                            width: 150,
                        },
                        {
                            Header: '身分',
                            accessor: 'user.vip.identity',
                            filterable: true,
                            Cell: row => ({
                                national: (<div><span role="img" aria-label="國內">🇹🇼</span> 國內</div>),
                                overseas: (<div><span role="img" aria-label="海外">🛳</span> 海外</div>),
                                foreigners: (<div><span role="img" aria-label="外籍">✈️</span> 外籍</div>),
                            }[row.value]),
                            Filter: ({ filter, onChange }) => (
                                <Select
                                    onChange={({ target: { value } }) => onChange(value)}
                                    style={{ width: '100%' }}
                                    value={filter ? filter.value : ''}
                                >
                                    <MenuItem value="all">全部</MenuItem>
                                    <MenuItem value="national">
                                        <span role="img" aria-label="國內">🇹🇼</span>
                                        國內
                                    </MenuItem>
                                    <MenuItem value="overseas">
                                        <span role="img" aria-label="海外">🛳</span>
                                        海外
                                    </MenuItem>
                                    <MenuItem value="foreigners">
                                        <span role="img" aria-label="外籍">✈️</span>
                                        外籍
                                    </MenuItem>
                                </Select>
                            ),
                            filterMethod: ({value}, {'user.vip.identity': identity}) => value === 'all' || value === identity,
                            width: 125,
                        },
                        {
                            Header: '所在地',
                            accessor: 'livingArea',
                            filterable: true,
                            width: 125,
                        },
                        {
                            Header: "發送類型",
                            accessor: "trigger_type",
                            filterable: true,
                            Cell: row => ({
                                manual: <div>手動發送</div>,
                                endOfTask: <div>自動發送</div>,
                            }[row.value]),
                            Filter: ({ filter, onChange }) => (
                                <Select
                                    onChange={({ target: { value } }) => onChange(value)}
                                    style={{ width: '100%' }}
                                    value={filter ? filter.value : ''}
                                >
                                    <MenuItem value="all">全部</MenuItem>
                                    <MenuItem value="manual">手動發送</MenuItem>
                                    <MenuItem value="endOfTask">自動發送</MenuItem>
                                </Select>
                            ),
                            filterMethod: ({ value }, { trigger_type }) => value === 'all' || value === trigger_type,
                            className: "justify-center",
                            width: 150,
                        },
                        {
                            Header: "最後發送時間",
                            accessor: "lastUpdate",
                            filterable: true,
                            className: "justify-center",
                            width: 150,
                        },
                        {
                            Header: "總發送次數",
                            accessor: "sent_count",
                            filterable: true,
                            className: "justify-center",
                            width: 150,
                        },
                        {
                            Header: "點擊次數",
                            accessor: "clicks",
                            filterable: true,
                            className: "justify-center",
                            width: 150,
                        },
                    ]}
                    defaultPageSize={5}
                />
            </FuseAnimate>
        );
    }


}

const styles = theme => ({
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    tooltip: {
        maxWidth: 100,
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

function mapStateToProps({global: {searchText}}) {
    return {searchText}
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(SurveyLinkList)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/survey/SurveyLinkList.js